<template>
  <div>
    <div class="m-2">
      <div class="d-flex w-100 align-items-center justify-content-between mb-2">
        <h4>Support Content</h4>
        <b-button @click="handleModalOpen()">Add new Content</b-button>
      </div>
      <b-form-input
        v-model="search"
        @input="searchSupportContent"
        placeholder="Search Content"
        class="mb-2"
      ></b-form-input>
      <div
        class="w-100 text-center font-weight-700 font-18"
        v-if="tableData && tableData.length === 0"
      >
        No Record Found
      </div>
      <b-table
        striped
        hover
        :items="tableData"
        :fields="tableFields"
        v-if="tableData && tableData.length !== 0"
      >
        <template v-slot:cell(action_buttons)="row">
          <b-button size="sm" @click="handleModalOpen(row.item)" class="mr-2"
            >Edit</b-button
          >
          <b-button
            size="sm"
            variant="danger"
            @click="deleteSupportContent(row.item.id)"
            >Delete</b-button
          >
        </template>

        <template v-slot:cell(description)="row">
          <div
            v-html="row.item.description"
            class="support-content-table-description"
          ></div>
        </template>

        <template v-slot:cell(video_url)="row">
          <iframe
            :src="row.item.youtube_video_url"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          ></iframe>
        </template>
      </b-table>
      <b-pagination
        v-if="tableData && tableData.length !== 0"
        align="center"
        v-model="page"
        :total-rows="totalRecords"
        :per-page="15"
        aria-controls="my-table"
      />
    </div>
    <b-modal
      id="content-support-modal"
      class="text-light"
      content-class="border-0"
      dialog-class="dashboard-create-challenge-dialog border-0"
      header-class="text-dark"
      @ok="save"
    >
      <template #modal-title>
        <span v-if="formData.id">Edit</span><span v-else>Create</span> Support
        Content
      </template>

      <b-form>
        <b-form-group
          id="question-group"
          class="textColor"
          label="Question"
          label-for="question-input"
        >
          <b-form-input
            id="question-input"
            v-model="formData.question"
            placeholder="Question"
            required
            type="text"
          ></b-form-input>
        </b-form-group>
        <b-form-group
          id="description-group"
          class="textColor"
          label="Description"
          label-for="description-input"
        >
          <vue-editor
            id="description-input"
            placeholder="Description"
            v-model="formData.description"
            :editorToolbar="vueEditorcustomToolbar"
          ></vue-editor>
        </b-form-group>
        <b-form-group
          id="video_url-group"
          class="textColor"
          label="Video URL"
          label-for="video_url-input"
        >
          <div class="d-flex align-items-start" style="column-gap: 10px;">
            <b-form-input
              id="video_url-input"
              v-model="formData.video_url"
              placeholder="Video URL"
              required
              type="text"
            ></b-form-input>

            <iframe
              width="50%"
              height="200"
              :src="iframeUrl"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen
            ></iframe>
          </div>
        </b-form-group>
        <div class="d-flex align-items-center" style="column-gap: 10px;">
          <b-form-group
            id="video_url-group"
            class="textColor w-75"
            label="Order"
            label-for="order_by-input"
          >
            <b-form-input
              id="order_by-input"
              v-model="formData.order_by"
              placeholder="Order by"
              required
              type="text"
            ></b-form-input>
          </b-form-group>

          <b-form-checkbox
            class="w-25"
            id="for_admin_only"
            v-model="formData.for_admin_only"
            name="for_admin_only"
            :value="true"
            :unchecked-value="false"
          >
            Only for Admin
          </b-form-checkbox>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>
<script>
import { VueEditor } from "vue2-editor";

function debounce(func, delay) {
  let timeoutId;

  return function(...args) {
    clearTimeout(timeoutId);

    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}

import api from "../api";
import EmbedID from "@/utils/youtubeEmbedID.js";

export default {
  name: "SupportContent",
  components: {
    VueEditor,
  },
  data: function() {
    return {
      isLoading: false,
      search: "",
      page: 1,
      pageSize: 15,
      totalRecords: 0,
      tableFields: [
        {
          key: "question",
          label: "Question",
        },
        {
          key: "description",
          label: "Description",
        },
        {
          key: "video_url",
          label: "Video",
        },
        {
          key: "for_admin_only",
          label: "Only for Admin",
        },
        {
          key: "order_by",
          label: "Order",
        },
        {
          key: "action_buttons",
          label: "Action Buttons",
        },
      ],
      tableData: [],
      formData: {
        id: null,
        question: "",
        description: "",
        video_url: "",
        for_admin_only: false,
        order_by: "",
      },
      vueEditorcustomToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
      ],
      iframeUrl: "",
    };
  },
  methods: {
    handleModalOpen(data) {
      if (data) {
        this.formData = data;
      } else {
        this.resetformData();
      }
      this.$bvModal.show("content-support-modal");
    },
    resetformData() {
      this.formData = {
        id: null,
        question: "",
        description: "",
        video_url: "",
        only_for_admin: false,
        order_by: "",
      };
    },
    async save(event) {
      event && event.preventDefault();
      if (this.formData.question === null || this.formData.question === "") {
        this.makeToast(
          "danger",
          "Field is Required",
          "Question cannot be blank"
        );
        return;
      }

      if (
        this.formData.description === null ||
        this.formData.description === ""
      ) {
        this.makeToast(
          "danger",
          "Field is Required",
          "Description cannot be blank"
        );
        return;
      }

      try {
        const formData = this.formData;
        const embedId = EmbedID.getEmbedID(formData.video_url);
        formData.video_url = `https://www.youtube.com/embed/${embedId}`
        if (!formData.order_by) {
          delete formData.order_by;
        }
        if (this.formData.id) {
          await api.updateSupportContent(this.formData.id, formData);
        } else {
          await api.createSupportContent(formData);
        }
        this.makeToast(
          "success",
          "Success",
          `Support Content ${this.formData.id ? "updated" : "saved"}`
        );
        this.$bvModal.hide("content-support-modal");
        this.resetformData();
        this.fetchSupportContent();
      } catch (error) {
        this.makeToast(
          "danger",
          "Error",
          `Failed to ${
            this.formData.id ? "edit" : "create new"
          } support content`
        );
      }
    },
    makeToast(variant, title, message) {
      this.$bvToast.toast(message, {
        title: title,
        variant: variant,
        solid: true,
        toaster: "b-toaster-bottom-right",
      });
    },
    async fetchSupportContent() {
      try {
        const response = await api.getSupportContent({
          search: this.search,
          page: this.page,
          pageSize: this.pageSize,
        });
        this.tableData = response.data.data.data;
        this.tableData = this.tableData.map((data) => {
          const embedId = EmbedID.getEmbedID(data.video_url);
          return {
            ...data,
            youtube_video_url: `https://www.youtube.com/embed/${embedId}`,
          };
        });
        this.totalRecords = response.data.data.totalRecords;
      } catch (error) {
        console.log(error);
      }
    },
    async deleteSupportContent(id) {
      try {
        const ctx = this;
        this.$swal
          .fire({
            title: "Do you want delete?",
            showDenyButton: true,
            confirmButtonText: "Yes",
            denyButtonText: `No`,
          })
          .then(async (result) => {
            if (result.isConfirmed) {
              await api.deleteSupportContent(id);
              ctx.fetchSupportContent();
            }
          });
      } catch (error) {
        console.log(error);
      }
    },
    searchSupportContent: debounce(function() {
      this.page = 1;
      this.fetchSupportContent();
    }, 300),
  },
  async mounted() {
    await this.fetchSupportContent();
  },
  watch: {
    page() {
      this.fetchSupportContent();
    },
    "formData.video_url": {
      handler() {
        const embedId = EmbedID.getEmbedID(this.formData.video_url);
        this.iframeUrl = `https://www.youtube.com/embed/${embedId}`;
      },
    },
  },
};
</script>
<style scoped lang="scss">
.dashboard-create-challenge-dialog .form-control {
  border: 1px solid #ced4da !important;
}

.support-content-table-description {
  max-height: 150px;
  max-width: 400px;
  overflow: scroll;
  padding-left: 20px;
}
</style>
